// ==================== Start Product Slider ====================
function ThumbnailPlugin(main) {
  return (slider) => {
    function removeActive() {
      slider.slides.forEach((slide) => slide.classList.remove("is-active"));
    }

    function addActive(idx) {
      slider.slides[idx].classList.add("is-active");
    }

    function addClickEvents() {
      slider.slides.forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          main.moveToIdx(idx);
        });
      });
    }

    slider.on("created", () => {
      addActive(main.track.details.rel);
      addClickEvents();

      main.on("animationStarted", (mainInstance) => {
        removeActive();
        const next = mainInstance.animator.targetIdx || 0;
        addActive(main.track.absToRel(next));

        
      });
    });
  };
}


const createProductSlider = function () {
  const gallery = document.querySelector(".product-media__gallery--slider");
  const thumbs = document.querySelector("#product-thumbs-slider");
  if (!gallery) return;

  const enableSlider = gallery.dataset.enableSlider === "true";
  const isDesktop = window.matchMedia("(min-width: 750px)").matches;

  // === Main slider ===
  const mainSlider = new KeenSlider(
    gallery,
    {
      slides: { perView: 1, spacing: 0, origin: "center" },
      loop: false,
      rubberband: false,
      renderMode: "precision",
      breakpoints: enableSlider
        ? {
            "(min-width: 750px)": {
              slides: { perView: 1, spacing: 0, origin: "center" },
            },
          }
        : { "(min-width: 750px)": { disabled: true } },
      slideChanged() {
        sliderDotsAnimation();
      },
      updated() {
        sliderDotsAnimation();
      },
      created(slider) {
      gallery.classList.add("is-initialized")
      },
    },
    [navigation]
  );

  gallery._keenSliderInstance = mainSlider;

  // === Sync heights for thumbs wrapper ===
  const mainWrapper = document.querySelector(".product-media__gallery--slider");
  const thumbsWrapper = document.querySelector(".product-thumbs-wrapper");

  if (mainWrapper && thumbsWrapper && isDesktop) {
    const syncHeights = () => {
      thumbsWrapper.style.height = mainWrapper.offsetHeight + "px";
      // Reveal thumbs only after height is applied
      thumbsWrapper.classList.add("is-synced")
    };

    // Run once immediately
    syncHeights();
    
    window.addEventListener("resize", syncHeights);
    window.addEventListener("load", syncHeights);
  }


  // === Init thumbnails only on desktop ===
  if (enableSlider && thumbs && isDesktop) {
   const thumbsSlider = new KeenSlider(
thumbs,
  {
    vertical: true,
    mode: "snap",
    rubberband: false,
    renderMode: "precision",
    drag: false,
    slides: {
      perView: "auto",
      spacing: 8,
    },
    breakpoints: {
      "(max-width: 749px)": {
        disabled: true,
      },
    },
    created(slider) {
      thumbs.classList.add("is-initialized")
    },
  },
  [ThumbnailPlugin(mainSlider)]
);
  thumbs.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })
thumbs.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false })

    // Arrows for thumbs
    const upArrow = document.querySelector(".thumbs-arrow--up");
    const downArrow = document.querySelector(".thumbs-arrow--down");

    if (upArrow && downArrow) {
      upArrow.addEventListener("click", () => {
        thumbsSlider.moveToIdx(Math.max(thumbsSlider.track.details.rel - 1, 0));
      });
      downArrow.addEventListener("click", () => {
        thumbsSlider.moveToIdx(
          Math.min(
            thumbsSlider.track.details.rel + 1,
            thumbsSlider.track.details.slides.length - 1
          )
        );
      });
    }
  }

  // === Keep Keen in sync with layout changes ===
  const mediaOuter = document.querySelector(".product-media__outer");
  if (mediaOuter && "ResizeObserver" in window) {
    new ResizeObserver(() => mainSlider.update()).observe(mediaOuter);
  }
  window.addEventListener("load", () => mainSlider.update(), { once: true });
  window.addEventListener("resize", () => {
    clearTimeout(window.__ks);
    window.__ks = setTimeout(() => mainSlider.update(), 120);
  });

  // === Main arrows ===
  const prevBtn = document.querySelector(".slider-arrow--left");
  const nextBtn = document.querySelector(".slider-arrow--right");
  if (isDesktop && prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => mainSlider.prev());
    nextBtn.addEventListener("click", () => mainSlider.next());
  } else {
    if (prevBtn) prevBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
  }
};

document.addEventListener("DOMContentLoaded", createProductSlider);
document.dispatchEvent(new CustomEvent("product:slider-ready"));

// ==================== End Product Slider ====================

// ==================== Start slider dots animation ====================
// Start helper functions
const createDotBackground = function () {
  const dots = document.querySelector(".product-media__gallery .dots");
  let dotBackground = dots.querySelector(".dot__background");
  if (dotBackground) return;
  dotBackground = document.createElement("span");
  dotBackground.classList.add("dot__background");
  dots.insertAdjacentElement("beforeend", dotBackground);
};

const updateDotBackground = function () {
  const dots = document.querySelector(".product-media__gallery .dots");
  const dotChildren = dots.querySelectorAll(".dot");
  const dotBackground = dots.querySelector(".dot__background");

  dotChildren.forEach((dot) => {
    if (dot.classList.contains("dot--active")) {
      dotBackground.style.width = `${parseInt(getComputedStyle(dot).width)}px`;
      dotBackground.style.left = `${dot.offsetLeft}px`;
    }
  });

  if (!dotBackground.classList.contains("animate")) {
    setTimeout(() => {
      dotBackground.classList.add("animate");
    }, 300);
  }
};
// End helper functions

const sliderDotsAnimation = function () {
  // 1. Create dotBackground element
  createDotBackground();

  // 2. Update dotBackground
  updateDotBackground();
};

document.addEventListener("DOMContentLoaded", sliderDotsAnimation);
// ==================== End slider dots animation ====================

// ==================== Start VariantRadios Class ====================
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.form = this.closest(".product-form");
    this.isBundleBuilder = this.form?.classList.contains(
      "product-form--bundle-builder"
    )
      ? true
      : false;
    this.bundleBuilderEl = this.isBundleBuilder
      ? this.closest(".bundle-builder")
      : "";
    this.multiAdd = this.form?.classList.contains("multi-add") ? true : false;
  }

  onVariantChange(e) {
    this.getSelectedOptions();
    this.getSelectedVariant();
    if (this.currentVariant && !this.multiAdd) {
      this.updateURL();
      this.updateFormID();
      this.updateProductInfo(e);
    }
    if (this.isBundleBuilder) {
      this.updateBundleBuilder();
    }

    if (this.multiAdd) {
      this.updateMultiAdd();
    }
  }

  getSelectedOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".js-product-form-option")
    );
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  getVariantJSON() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return option === this.options[index];
        })
        .includes(false);

      if (findings) return variant;
    });
  }

  updateURL() {
    if (!this.currentVariant) return;

    if (!this.isBundleBuilder) {
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }
  }

  updateFormID() {
    const formInput = this.form.querySelector('input[name="id"]');
    formInput.value = this.currentVariant.id;
  }

  updateProductInfo(e) {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const idPrice = `price-${this.dataset.section}`;
        const idMedia = `media-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const oldPriceDesktop = document
          .querySelector(".product-info-above-description-desktop")
          .querySelector(`#${idPrice}`);
        const newPriceDesktop = html
          .querySelector(".product-info-above-description-desktop")
          .querySelector(`#${idPrice}`);
        const oldPriceMobile = document
          .querySelector(".product-info-above-description-mobile")
          .querySelector(`#${idPrice}`);
        const newPriceMobile = html
          .querySelector(".product-info-above-description-mobile")
          .querySelector(`#${idPrice}`);
        const oldAfterpay = document.querySelector(".product__afterpay");
        const newAfterpay = html.querySelector(".product__afterpay");
        const oldProductMedia = document.getElementById(idMedia);
        const newProductMedia = html.getElementById(idMedia);
        const currentVariantColor = this.form.querySelector(
          ".option-heading__current-color"
        );
        const oldCTA = this.form.querySelector(".product-form__cta");
        const newCTA = html.querySelector(".product-form__cta");
        const oldPreorderModal = document.querySelector(
          ".preorder-confirmation-modal"
        );
        const newPreorderModal = html.querySelector(
          ".preorder-confirmation-modal"
        );
        const oldDetailsTab = document.querySelector(
          ".product-tab.tab-the-details .product-tab__content"
        );
        const newDetailsTab = html.querySelector(
          ".product-tab.tab-the-details .product-tab__content"
        );
        const oldModelInfoDesktop = document.querySelector(
          ".model-info--desktop"
        );
        const newModelInfoDesktop = html.querySelector(".model-info--desktop");
        const oldModelInfofit = document.querySelector(
          ".fit-review__title--fit"
        );
        const newModelInfofit = html.querySelector(".fit-review__title--fit");
        const oldFeaturedImage = document.querySelector(
          ".product-media__gallery--slider .keen-slider__slide:first-child img"
        );
        const newFeaturedImage = html.querySelector(
          ".product-media__gallery--slider .keen-slider__slide:first-child img"
        );
        const oldOptionHeadingColor = this.form.querySelector(
          ".option-heading--color"
        );
        const newOptionHeadingColor = html.querySelector(
          ".option-heading--color"
        );
        const oldDescription = document.querySelector(".product-description");
        const newDescription = html.querySelector(".product-description");
        const oldDescriptionAll = document.querySelectorAll(
          ".js-product-description"
        );
        const bundleSavingMessage = document.querySelector(".bundle-builder__savings-message");

        // Update Price
        if (!this.isBundleBuilder) {
          if (oldPriceDesktop && newPriceDesktop)
            oldPriceDesktop.innerHTML = newPriceDesktop.innerHTML;
          if (oldPriceMobile && newPriceMobile)
            oldPriceMobile.innerHTML = newPriceMobile.innerHTML;
          if (oldAfterpay && newAfterpay)
            oldAfterpay.innerHTML = newAfterpay.innerHTML;
        }else{
          // is bundle
          const bundleType = document.querySelector('.bundle-builder');
          const skipLastChancePricingLogic = bundleType.dataset.skipLastChancePricingLogic;
          if (skipLastChancePricingLogic == 'true') { return; }

          let formattedBasePrice = "";
          let formatedSavings = "";
          let priceHolderDesktop = "";
          let priceHolderMobile = "";
          if (bundleType.classList.contains('bundle-builder--pack')) {
            formattedBasePrice = bundleSavingMessage.dataset.basePrice;
            formatedSavings =  bundleSavingMessage.dataset.bundleBaseSaveAmount;
            priceHolderDesktop = oldPriceDesktop.parentElement.querySelector(".pack-price");
            priceHolderMobile = oldPriceMobile.parentElement.querySelector(".pack-price");
          }else {
            formattedBasePrice = oldPriceDesktop.querySelector(".price").dataset.basePrice;
            formatedSavings =  oldPriceDesktop.querySelector(".price").dataset.bundleBaseSaveAmount;
            priceHolderDesktop = oldPriceDesktop.querySelector(".price-item--regular");
            priceHolderMobile = oldPriceMobile.querySelector(".price-item--regular");
          }
          let baseBundlePrice = parseFloat(formattedBasePrice.replace(/[^0-9.]/g, ''));
          let currency = formattedBasePrice.replace(/[0-9.]/g, '');
          // bundle saving label
          let lastChanceSavings = 0;
          let renderedSavings = parseFloat(formatedSavings.replace(/[^0-9.]/g, ''));
          // bundle last chance savings
          document.querySelectorAll("bundle-builder-row").forEach(row => {
          if (row.dataset.lastChanceSavings && row.dataset.lastChanceSavings != "0")
              lastChanceSavings +=  ( parseFloat(row.dataset.lastChanceSavings));
          })
          if (lastChanceSavings != 0) {
            // calculate new price 
            let discountedBundlePrice = baseBundlePrice - lastChanceSavings;
            let formattedDisctountedPrice = currency + discountedBundlePrice;
            renderedSavings += lastChanceSavings;        




           priceHolderDesktop.innerHTML = formattedDisctountedPrice;

            const priceWrapDesktop = oldPriceDesktop?.closest(".product-info-above-description-desktop");
            const savingLabelDesktop = priceWrapDesktop?.querySelector(".product-price__saving-label");
            if (savingLabelDesktop) {
              savingLabelDesktop.innerText = "Save " + currency + renderedSavings;
            }

            priceHolderMobile.innerHTML = formattedDisctountedPrice;

            const priceWrapMobile = oldPriceMobile?.closest(".product-info-above-description-mobile");
            const savingLabelMobile = priceWrapMobile?.querySelector(".product-price__saving-label");
            if (savingLabelMobile) {
              savingLabelMobile.innerText = "Save " + currency + renderedSavings;
            }

           
           
           
           
            // update pack saving message
            bundleSavingMessage.querySelector(".total").innerText = formattedDisctountedPrice;
            bundleSavingMessage.querySelector(".savings").innerText = currency + renderedSavings;
            // update afterpay money 
            document.querySelector(".afterpay-price").innerHTML = currency +  (discountedBundlePrice / 4).toFixed(0);


          }else {
            priceHolderDesktop.innerHTML = formattedBasePrice;
            priceHolderMobile.innerHTML = formattedBasePrice;

            const priceWrapDesk = oldPriceDesktop?.closest(".product-info-above-description-desktop");
            const savingLabelDesk = priceWrapDesk?.querySelector(".product-price__saving-label");
            if (savingLabelDesk) savingLabelDesk.innerText = "Save " + currency + renderedSavings;

            const priceWrapMob = oldPriceMobile?.closest(".product-info-above-description-mobile");
            const savingLabelMob = priceWrapMob?.querySelector(".product-price__saving-label");
            if (savingLabelMob) savingLabelMob.innerText = "Save " + currency + renderedSavings;

            const bundleTotal = bundleSavingMessage?.querySelector(".total");
            if (bundleTotal) bundleTotal.innerText = formattedBasePrice;

            const bundleSavings = bundleSavingMessage?.querySelector(".savings");
            if (bundleSavings) bundleSavings.innerText = formatedSavings;

            const afterpayPrice = document.querySelector(".afterpay-price");
            if (afterpayPrice) afterpayPrice.innerHTML = currency + (baseBundlePrice / 4).toFixed(0);
          }
        }

        // Update CTA buttons
        if (oldCTA && newCTA) oldCTA.innerHTML = newCTA.innerHTML;
        addToCartBtnFunction();

        // Update Preorder Modal
        if (!this.isBundleBuilder) {
          if (oldPreorderModal && newPreorderModal)
            oldPreorderModal.innerHTML = newPreorderModal.innerHTML;
          preorderFunction();
        }

        // Update custom color details
        if (!this.isBundleBuilder) {
          // Update description
          if (oldDescription && newDescription) {
            oldDescriptionAll.forEach(
              (el) => (el.innerHTML = newDescription.innerHTML)
            );
          }

          if (oldDetailsTab && newDetailsTab)
            oldDetailsTab.innerHTML = newDetailsTab.innerHTML;
          productDimensions();
          learnMoreFunction();
          micronChart();
          micronModalFunction();
        }

       if (oldFeaturedImage.dataset.id !== newFeaturedImage.dataset.id) {
          // 💡 Check if product has excluded Black Friday tags
          const productTags = window?.productData?.tags || [];
          const skipGalleryUpdate = productTags.some(tag =>
            ["black-friday-giftset", "black-friday-variety", "black-friday-ownbox"].includes(tag)
          );

          // ✅ Only update gallery if NOT a Black Friday special
          if (!skipGalleryUpdate) {
            if (oldProductMedia && newProductMedia) {
              const oldGalleryEl = document.querySelector('.product-media__gallery--slider');
              const oldGalleryBottom = oldGalleryEl
                ? oldGalleryEl.getBoundingClientRect().bottom + window.scrollY
                : window.scrollY;

              oldProductMedia.innerHTML = newProductMedia.innerHTML;
              this.recreateSlider(oldGalleryBottom);
            }
          } else {
            console.log("🛑 Skipping gallery update for Black Friday product:", productTags);
          }

          // Enable Image Zoom (optional — you can also skip if you want)
          featuredImagesZoom();


        // Model Info - Desktop
        if (oldModelInfoDesktop && newModelInfoDesktop) {
          oldModelInfoDesktop.innerHTML = newModelInfoDesktop.innerHTML;
        } else {
          oldModelInfoDesktop.innerHTML = '';
        }
        // Model Info - fit review
       if (oldModelInfofit && newModelInfofit) {
        oldModelInfofit.innerHTML = newModelInfofit.innerHTML;
      } else if (oldModelInfofit) {
        oldModelInfofit.innerHTML = '';
      }



          // Update Current Variant Color
          if (currentVariantColor) {
            currentVariantColor.innerHTML = this.currentVariant.option1;
          }



          // Model Info - Desktop
          if (oldModelInfoDesktop && newModelInfoDesktop) {
            oldModelInfoDesktop.innerHTML = newModelInfoDesktop.innerHTML;
          } else {
            oldModelInfoDesktop.innerHTML = "";
          }
          // Model Info - fit review
          if (oldModelInfofit && newModelInfofit) {
            oldModelInfofit.innerHTML = newModelInfofit.innerHTML;
          } else if (oldModelInfofit) {
            oldModelInfofit.innerHTML = "";
          }

          // Model Info - Mobile
          modelInfoMobile();
        }

        // check Available Options
        this.checkAvailableOptions(e, html);

        // Hide BIS hidden options
        hideBIShiddenOptions();

        // Select a Size
        selectASizeBtnClick();

        if (!this.isBundleBuilder) {
          if (this.form.classList.contains("product-form--size-selected")) {
            this.form.classList.add("product-info-updated");
          }
        }

        // Customer Images Section
        // customerImgesFunction();

        // The Fit
        checkTheFitContent();
        adjustActiveProductTabHeight();

        // hide info__notify-me when discontinued_colors
        if (!this.isBundleBuilder) {
          const notifyMeLink = document.querySelector(".info__notify-me");
          let hideNotifyMe = false;
          if (typeof discontinued_colors !== "undefined" && notifyMeLink) {
            const discontinuedArray = discontinued_colors
              .split(",")
              .map((color) => color.trim().toLowerCase());
            const currentColor = currentVariantColor.innerText
              .trim()
              .toLowerCase();
            if (discontinuedArray.includes(currentColor)) {
              hideNotifyMe = true;
            }
          }

          if (notifyMeLink && hideNotifyMe) {
            notifyMeLink.classList.remove("active");
          }
        }

        // Option heading - color
        if (oldOptionHeadingColor && newOptionHeadingColor)
          oldOptionHeadingColor.innerHTML = newOptionHeadingColor.innerHTML;
      });
  }

  recreateSlider(oldGalleryBottom) {
    createProductSlider();
    // Query the newly created gallery element
    const gallery = document.querySelector('.product-media__gallery--slider');

    // Wait for new gallery height to stabilize before adjusting scroll
    requestAnimationFrame(() => {
      if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(() => {
          const newGalleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY;
          const heightDiff = newGalleryBottom - oldGalleryBottom;

          if (heightDiff >= 0) {
            observer.disconnect();
            return;
          }

          // Keep scroll position aligned with the gallery change
          window.scrollBy({
            top: heightDiff,
            behavior: 'smooth',
          });

          observer.disconnect();
        });

        observer.observe(gallery);
      } else {
        // Fallback for environments without ResizeObserver
        setTimeout(() => {
          const newGalleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY;
          const heightDiff = newGalleryBottom - oldGalleryBottom;

          if (heightDiff >= 0) {
            return;
          }

          window.scrollBy({ top: heightDiff, behavior: 'smooth' });
        }, 0);
      }
    });
  }

  checkAvailableOptions(e, html) {
    if (!e) return;
    // When 'Color' or 'Size' is clicked
    if (
      e.target.attributes.option.nodeValue === "Color" ||
      e.target.attributes.option.nodeValue === "Size"
    ) {
      const form = e.target.closest(".product-form");
      const allInputs = form.querySelectorAll("input");
      const selectedColorVariants = this.getVariantJSON().filter((variant) => {
        const currentSelectedColor = html.querySelector(
          '.product-form input[option="Color"][checked]'
        ).value;
        return variant.option1 === currentSelectedColor;
      });
      let thirdInputs = form.querySelectorAll('input[option="Inseam"]');
      if (thirdInputs.length === 0) {
        thirdInputs = form.querySelectorAll('input[option="Length"]');
      }
      const sizeInputs = form.querySelectorAll('input[option="Size"]');
      const notifyMeLink = document.querySelector(".info__notify-me");

      // 1- Reset
      allInputs.forEach((input) => {
        input.classList.remove("disabled");
        input.setAttribute("data-counter", 0);
      });
      if (notifyMeLink) notifyMeLink.classList.remove("active");

      // 2- Add 'disabled' class to out of stock options
      selectedColorVariants.forEach((variant) => {
        if (!variant.available) {
          // ========== If Size Only ==========
          if (variant.option2 && !variant.option3)
            this.checkSizesOnly(sizeInputs, variant);

          // ========== If Size & Third ==========
          if (variant.option2 && variant.option3)
            this.checkSizesAndThird(
              sizeInputs,
              thirdInputs,
              variant,
              selectedColorVariants,
              html
            );
        }
      });

      // 3- Notify Me Link - If at lease there's one variant OOS
      if (selectedColorVariants.some((variant) => !variant.available)) {
        if (notifyMeLink) notifyMeLink.classList.add("active");
      }
    }
  }

  checkSizesOnly(sizeInputs, variant) {
    sizeInputs.forEach((input) => {
      if (variant.option2 === input.value) input.classList.add("disabled");
    });
  }

  checkSizesAndThird(
    sizeInputs,
    thirdInputs,
    variant,
    selectedColorVariants,
    html
  ) {
    // ===== First ===== Disable Size Option if all Thirds are not available
    sizeInputs.forEach((inputSize) => {
      if (variant.option2 === inputSize.value)
        inputSize.setAttribute(
          "data-counter",
          `${Number(inputSize.getAttribute("data-counter")) + 1}`
        );

      // If the 'data-counter' value = the number of Third Inputs, means all thirds are not available for this size
      // We can now disable this size
      if (
        Number(inputSize.getAttribute("data-counter")) === thirdInputs.length
      )
        inputSize.classList.add("disabled");
    });

    // ===== Second ===== Disable OOS Third Options
    // 1- Get Current Checked Size
    const currentSize = html.querySelector(
      '.product-form input[option="Size"][checked]'
    );

    // 2- Get all variants with the same checked size
    // 3- If variant is not available, disable the third option
    selectedColorVariants.forEach((el) => {
      if (el.option2 === currentSize.value && !el.available) {
        thirdInputs.forEach((inputThird) => {
          if (el.option3 === inputThird.value)
            inputThird.classList.add("disabled");
        });
      }
    });
  }

  updateBundleBuilder() {
    // 1. Check if current variant is available
    const confirmBtn = this.form.querySelector(".bundle-builder__confirm");
    const bundleBuilderATC = this.bundleBuilderEl.querySelector(
      ".bundle-builder-add-to-cart"
    );
    const soldOutEl = this.form.querySelector(".bundle-builder__sold-out");
    const bundleBuilderRowHeaders = this.bundleBuilderEl.querySelectorAll(
      ".bundle-builder-row__header"
    );
    const thisRow = this.form.closest(".bundle-builder-row");
    const bundleBuilderStepHeaders = document.querySelectorAll(
      ".bundle-builder-step__header"
    );

    if (!this.currentVariant.available) {
      // 1. Restrict this row
      thisRow.classList.add("restricted");

      // 2. Restrict all headers
      bundleBuilderRowHeaders.forEach((el) => el.classList.add("restricted"));

      // 3. Restrict confirm button
      confirmBtn.classList.add("restricted");

      // 4. Restrict ATC button
      bundleBuilderATC.classList.add("restricted");

      // 5. Show sold out
      soldOutEl.classList.remove("hidden");

      // 6. Adjust row height
      thisRow.heightAnimation();

      // 6. Disable Step heading
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach((el) =>
          el.classList.add("restricted")
        );
      }
    } else {
      thisRow.classList.remove("restricted");
      bundleBuilderRowHeaders.forEach((el) =>
        el.classList.remove("restricted")
      );
      confirmBtn.classList.remove("restricted");
      bundleBuilderATC.classList.remove("restricted");
      soldOutEl.classList.add("hidden");
      thisRow.heightAnimation();
      if (bundleBuilderStepHeaders.length > 0) {
        bundleBuilderStepHeaders.forEach((el) =>
          el.classList.remove("restricted")
        );
      }
    }

    // 2. Show selected variant title
    const selectedVariantEl = this.form
      .closest(".bundle-builder-row")
      .querySelector(".bundle-builder-row__selected-variant");
    let selectedVariantTitle;

    setTimeout(() => {
      const selectedStyle = this.form
        .closest(".bundle-builder-row")
        .querySelector('.style-icon input[type="radio"]:checked');

      if (selectedStyle) {
        const styleTitle = selectedStyle
          .closest(".style-icon")
          .querySelector(".style-icon__title").textContent;
        selectedVariantTitle = `${styleTitle} / ${this.currentVariant.title}`;
      } else {
        selectedVariantTitle = this.currentVariant.title;
      }

      selectedVariantEl.textContent = selectedVariantTitle;

      // 3. check if the selected variant is a last chance or not
      const lastChanceColors = this.closest(".product-form").dataset.lastChanceColors.split(",").map(c => c.trim().toLowerCase());
      const lastChanceSavings = this.closest(".product-form").dataset.savings;
      if (lastChanceColors.length > 0 && parseFloat(lastChanceSavings) != 0) {
        const match = lastChanceColors.find(color =>  selectedVariantTitle.toLowerCase().includes(color) );
        this.closest(".bundle-builder-row").dataset.lastChanceSavings = match ? lastChanceSavings : '0';        
      }else{
        this.closest(".bundle-builder-row").dataset.lastChanceSavings = '0';         
      }
    }, 300);

  }

  updateMultiAdd() {
    this.getAvailableOptions();
    this.getAvailableVariants();
    this.addVariantsInfo();
    this.resetQuantity();
  }

  getAvailableOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".js-product-form-option")
    );
    let currentSize;
    let allColors = [];
    let availableOptions = [];
    let availableOptionsArray = [];
    let arraySize = 2;

    fieldsets.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        if (
          input.getAttribute("option") === "Size" ||
          input.getAttribute("option") === "size"
        ) {
          if (input.checked) currentSize = input.value;
        } else if (
          input.getAttribute("option") === "Color" ||
          input.getAttribute("option") === "color"
        ) {
          allColors.push(input.value);
        }
      });
    });

    allColors.forEach((color) => {
      availableOptions.push(color, currentSize);
    });

    for (let i = 0; i < availableOptions.length; i += arraySize) {
      availableOptionsArray.push(availableOptions.slice(i, i + arraySize));
    }

    return availableOptionsArray;
  }

  getAvailableVariants() {
    const availableOptionsArray = this.getAvailableOptions();
    let availableVariantsArray = [];

    availableOptionsArray.forEach((el) => {
      let availableVariant = this.getVariantJSON().find((variant) => {
        const findings = !variant.options
          .map((option, index) => {
            return option === el[index];
          })
          .includes(false);

        if (findings) return variant;
      });

      availableVariantsArray.push(availableVariant);
    });

    return availableVariantsArray;
  }

  addVariantsInfo() {
    const availableVariantsArray = this.getAvailableVariants();
    const multiAddColorContainers = document.querySelectorAll(
      ".multi-add__color-container"
    );

    multiAddColorContainers.forEach((container) => {
      const containerColor = container.dataset.color;
      const OOSLabel = container.querySelector(".color-swatch__OOS");
      const quantityBtns = container.querySelectorAll(".quantity__button");
      const preorderLabel = container.querySelector(".color-swatch__preorder");

      availableVariantsArray.forEach((variant) => {
        if (variant.option1 === containerColor) {
          container.setAttribute("variant-id", variant.id);
          container.setAttribute(
            "available-quantity",
            variant.inventory_quantity
          );

          if (variant.inventory_quantity < 1) {
            OOSLabel.classList.remove("hidden");
            quantityBtns.forEach((btn) => btn.classList.add("disabled"));
            preorderLabel.classList.add("hidden");
          } else {
            OOSLabel.classList.add("hidden");
            quantityBtns.forEach((btn) => btn.classList.remove("disabled"));
            if (container.hasAttribute("data-preorder"))
              preorderLabel.classList.remove("hidden");
          }
        }
      });
    });
  }

  resetQuantity() {
    const allQuantityInputs = document.querySelectorAll(
      ".multi-add__quantity-input"
    );
    const counter = document.querySelector(
      ".multi-add__counter .selected-counter"
    );
    const multiAddAddToCartBtn = document.querySelector(
      ".multi-add-add-to-cart"
    );
    allQuantityInputs.forEach((input) => (input.value = 0));
    counter.textContent = 0;
    multiAddAddToCartBtn.innerHTML = "Select Colors";
    multiAddAddToCartBtn.classList.add("disabled");
  }
}

customElements.define("variant-radios", VariantRadios);
// ==================== End VariantRadios Class ====================

// ==================== Start Upsell Popup ====================
class UpsellPopup extends HTMLElement {
  constructor() {
    super();
    this.addToCartBtns = this.querySelectorAll(".upsell-popup__add-to-cart");
    this.headers = this.querySelectorAll(".upsell-popup__header");
    this.price = this.querySelector(".upsell-popup__price");
    this.shopNowBtn = this.querySelector(".upsell-popup__shop");

    document.addEventListener(
      "DOMContentLoaded",
      this.updateUpsellInfo.bind(this)
    );
    this.addEventListener("click", this.onUpsellPopupClick.bind(this));
    window.addEventListener("keydown", this.onKeydownClick.bind(this));
    this.addToCartBtns.forEach((btn) => {
      btn.addEventListener("click", this.onAddToCartBtnClick.bind(this));
    });
    this.shopNowBtn.addEventListener(
      "click",
      this.onShopNowBtnClick.bind(this)
    );
  }

  updateUpsellInfo() {
    const bundleBuilderSavings = document.querySelector(
      ".bundle-builder__savings-message"
    );

    // 1. Header
    this.headers.forEach(
      (header) =>
        (header.textContent = bundleBuilderSavings?.dataset.upsellHeader)
    );

    // 2. Price
    this.price.textContent = bundleBuilderSavings?.dataset.upsellPrice;
  }

  openUpsellPopup() {
    this.classList.remove("hidden");
  }

  closeUpsellPopup() {
    this.classList.add("hidden");
  }

  onUpsellPopupClick(e) {
    if (e.target === this) {
      this.closeUpsellPopup();
      updateCart();
    }
  }

  onKeydownClick(e) {
    if (e.key === "Escape") {
      if (!this.classList.contains("hidden")) updateCart();
      this.closeUpsellPopup();
    }
  }

  onAddToCartBtnClick() {
    this.closeUpsellPopup();
    updateCart();
  }

  onShopNowBtnClick() {
    const packSelector = document.querySelector(
      '.singles-and-packs__btn[data-type="packs"]'
    );
    const productInfoInner = document.querySelector('.product-info__inner');

    this.closeUpsellPopup();
    packSelector.click();
    if (productInfoInner) {
    productInfoInner.classList.add('pack');
    }
  }
}

customElements.define("upsell-popup", UpsellPopup);
// ==================== End Upsell Popup ====================

// ==================== Start Form Add to Cart Button ====================
// ===== Start Helper Functions =====
const updateCart = function () {
  const cart = document.querySelector("cart-drawer");
  const form = document.querySelector(".product-form #product-form");

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(form);
  if (cart) {
    formData.append(
      "sections",
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      cart.renderContents(response);
      cart.openCloseCart();
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (cart && cart.classList.contains("is-empty"))
        cart.classList.remove("is-empty");
    });
};
// ===== End Helper Functions =====

const addToCartBtnFunction = function () {
  const addToCartBtn = document.querySelector(
    ".product-form__cta .add-to-cart-button"
  );
  const upsellPopup = document.querySelector(".upsell-popup");

  if (!addToCartBtn) return;

  addToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (upsellPopup) {
      // Check Cookie
      const cookieName = `upsellPopup-${
        document.querySelector(".main-product").dataset.handle
      }`;
      const upsellPopupCookie = getCookie(cookieName);

      if (upsellPopupCookie) {
        // upsellPopupCookie = True, means the user already saw it
        // Then add to cart
        updateCart();
      } else {
        // 1- Open upsell popup
        upsellPopup.openUpsellPopup();
        // 2- Update Cookies
        setCookie(cookieName, true, 1);
      }
    } else {
      updateCart();
    }
  });
};

document.addEventListener("DOMContentLoaded", addToCartBtnFunction);
// ==================== End Form Add to Cart Button ====================

// ==================== Start Check Unavailable options on load ====================
// Helper Function
const checkSizesAndThirdOnLoad = function (
  sizeInputs,
  thirdInputs,
  variant,
  selectedColorVariants
) {
  // ===== First ===== Disable Size Option if all Thirds are not available
  sizeInputs.forEach((inputSize) => {
    if (variant.option2 === inputSize.value)
      inputSize.setAttribute(
        "data-counter",
        `${Number(inputSize.getAttribute("data-counter")) + 1}`
      );

    // If the 'data-counter' value = the number of Third Inputs, means all thirds are not available for this size
    // We can now disable this size
    if (Number(inputSize.getAttribute("data-counter")) === thirdInputs.length)
      inputSize.classList.add("disabled");
  });

  // ===== Second ===== Disable OOS Third Options
  // 1- Get Current Checked Size
  const currentSize = document.querySelector(
    '.product-form input[option="Size"][checked]'
  );

  // 2- Get all variants with the same checked size
  // 3- If variant is not available, disable the third option
  selectedColorVariants.forEach((el) => {
    if (el.option2 === currentSize.value && !el.available) {
      thirdInputs.forEach((inputThird) => {
        if (el.option3 === inputThird.value)
          inputThird.classList.add("disabled");
      });
    }
  });
};

const checkAvailableOptionsOnLoad = function () {
  const forms = document.querySelectorAll(".product-form:not(.multi-add)");

  forms.forEach((form) => {
    const productHandle = form.getAttribute("data-handle");
    const url = `/products/${productHandle}.js`;
    const selectedColor = form.querySelector(".option-heading__current-color");
    let selectedColorVariants = [];
    let thirdInputs = form.querySelectorAll('input[option="Inseam"]');
    if (thirdInputs.length === 0) {
      thirdInputs = form.querySelectorAll('input[option="Length"]');
    }
    const sizeInputs = form.querySelectorAll('input[option="Size"]');
    const notifyMeLink = document.querySelector(".info__notify-me");

    if (!selectedColor) return;

    // Product API
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.variants.forEach((variant) => {
          if (variant.option1 === selectedColor.textContent)
            selectedColorVariants.push(variant);
        });

        // Add 'disabled' class to out of stock options
        selectedColorVariants.forEach((variant) => {
          if (!variant.available) {
            // ========== If Size Only ==========
            if (variant.option2 && !variant.option3) {
              sizeInputs.forEach((input) => {
                if (variant.option2 === input.value)
                  input.classList.add("disabled");
              });
            }

            // ========== If Size & Third ==========
            if (variant.option2 && variant.option3)
              checkSizesAndThirdOnLoad(
                sizeInputs,
                thirdInputs,
                variant,
                selectedColorVariants
              );
          }
        });

        // only for normal products (there's no notify me link for bundles):
        let isBundleBuilder = form.classList.contains(
          "product-form--bundle-builder"
        )
          ? true
          : false;
        if (!isBundleBuilder && notifyMeLink) {
          let hideNotifyMe = false;
          // - Check If the current color is discontinued → don't show the "Notify Me" link
          if (typeof discontinued_colors !== "undefined") {
            const discontinuedArray = discontinued_colors
              .split(",")
              .map((color) => color.trim().toLowerCase());
            const currentColor = selectedColor.innerHTML.trim().toLowerCase();
            if (discontinuedArray.includes(currentColor)) {
              hideNotifyMe = true;
            }
          }

          if (hideNotifyMe) {
            notifyMeLink.classList.remove("active");
          } else if (
            !hideNotifyMe &&
            selectedColorVariants.some((variant) => !variant.available)
          ) {
            // - Else if the current color is not discontinued:
            //     - Check if any variants are out of stock
            //     - If some variants are out of stock → show the "Notify Me" link
            notifyMeLink.classList.add("active");
          }
        }
      });
  });
};
checkAvailableOptionsOnLoad();
// ==================== End Check Unavailable options on load ====================

// ==================== Start Model Info ====================
const modelInfoMobile = function () {
  const allModelInfo = document.querySelectorAll(".model-info--mobile");
  allModelInfo.forEach((el) => {
    const modelInfoContainer = el.querySelector(".model-info-inner");
    const modelInfoTitle = el.querySelector(".model-info__title");
    const customerImagesBtns = document.querySelectorAll(
      ".customer-images-btn"
    );

    el.addEventListener("click", function () {
      // 1- Toggle Title
      modelInfoTitle.classList.toggle("hidden");

      // 2- Adjust width
      if (modelInfoTitle.classList.contains("hidden"))
        modelInfoContainer.style.display = "block";
      else modelInfoContainer.style.display = "none";

      // 3- Show/Hide Customer Image Button
      if (modelInfoTitle.classList.contains("hidden")) {
        customerImagesBtns.forEach((btn) => btn.classList.add("hidden"));
      } else {
        customerImagesBtns.forEach((btn) => btn.classList.remove("hidden"));
      }
    });
  });
};
modelInfoMobile();
// ==================== End Model Info ====================

// ==================== Start Related Bundles ====================
class RelatedBundles extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector(".related-bundles__header");
    this.allSavings = this.querySelectorAll(".bundle-option__saving");
    this.savingUpTo = this.querySelector(".related-bundles__up-to");

    this.header.addEventListener("click", this.onHeaderClick.bind(this));
    window.addEventListener("resize", this.adjustHeight.bind(this));
    document.addEventListener(
      "DOMContentLoaded",
      this.highestSavings.bind(this)
    );
  }

  onHeaderClick() {
    // 1. 'active' class
    this.classList.toggle("active");

    // 2. Open or close
    this.adjustHeight();
  }

  adjustHeight() {
    const content = this.querySelector(".related-bundles__content");
    const contentContainer = this.querySelector(
      ".related-bundles__content-container"
    );

    if (this.classList.contains("active"))
      content.style.maxHeight = getComputedStyle(contentContainer).height;
    else content.style.maxHeight = 0;
  }

  highestSavings() {
    const highestSavings = [...this.allSavings]
      .map((saving) => parseInt(saving.textContent.trim().match(/\d+/)[0]))
      .reduce((prev, cur) => (prev > cur ? prev : cur));

    this.savingUpTo.textContent = `Save up to ${this.savingUpTo.dataset.currency}${highestSavings}`;
  }
}

customElements.define("related-bundles", RelatedBundles);
// ==================== End Related Bundles ====================

// ==================== Start Product Tabs ====================
const productTabsFunction = function () {
  const productTabs = document.querySelectorAll(".product-tab");
  const productTabsHeadings = document.querySelectorAll(
    ".product-tab__heading"
  );

  productTabsHeadings.forEach((heading) => {
    heading.addEventListener("click", function () {
      const thisTab = heading.closest(".product-tab");
      const productTabContainer = thisTab.querySelector(
        ".product-tab__content-container"
      );
      const productTabHeight = getComputedStyle(
        productTabContainer.querySelector(".product-tab__content")
      ).height;

      // 1) Active class
      if (thisTab.classList.contains("active")) {
        thisTab.classList.remove("active");
      } else {
        productTabs.forEach((el) => el.classList.remove("active"));
        thisTab.classList.add("active");
      }

      // 2) Content Animation
      if (thisTab.classList.contains("active")) {
        // Close all Tabs
        productTabs.forEach(
          (el) =>
            (el.querySelector(
              ".product-tab__content-container"
            ).style.maxHeight = 0)
        );
        // Open this tab
        productTabContainer.style.maxHeight = productTabHeight;
      } else {
        // Close this tab
        productTabContainer.style.maxHeight = 0;
      }
    });
  });
};

const adjustActiveProductTabHeight = function () {
  const productTabs = [...document.querySelectorAll(".product-tab")];
  const [activeProductTab] = productTabs.filter((tab) =>
    tab.classList.contains("active")
  );
  if (!activeProductTab) return;
  const activeProductTabContainer = activeProductTab.querySelector(
    ".product-tab__content-container"
  );
  const activeProductTabHeight = getComputedStyle(
    activeProductTabContainer.querySelector(".product-tab__content")
  ).height;

  activeProductTabContainer.style.maxHeight = activeProductTabHeight;
};

// Adjust Features tab Height on load
const adjustFeaturesTabHeightOnLoad = function () {
  const featuredTabContainer = document.querySelector(
    ".tab-features .product-tab__content-container"
  );
  if (!featuredTabContainer) return;
  const featuredTabHeight = getComputedStyle(
    featuredTabContainer.querySelector(".product-tab__content")
  ).height;

  featuredTabContainer.style.maxHeight = featuredTabHeight;
};

// The Fit
const checkTheFitContent = function () {
  const theFit = document.querySelector(".tab-the-fit");
  const theFitContent = theFit.querySelector(".product-tab__content");

  if (theFitContent.textContent.trim()) theFit.classList.remove("hidden");
};

productTabsFunction();
adjustFeaturesTabHeightOnLoad();
checkTheFitContent();
adjustActiveProductTabHeight();
// ==================== End Product Tabs ====================

// ==================== Start Learn More Scroll ====================
const learnMoreFunction = function () {
  const descriptionLearnMore = document.querySelector(
    ".product-description--learn-more"
  );
  if (!descriptionLearnMore) return;

  descriptionLearnMore.addEventListener("click", function () {
    const headerHeight = parseInt(
      getComputedStyle(document.querySelector(".mega-sticky-header")).height
    );
    const productNavHeight = document.querySelector(".sticky-product-nav")
      ? parseInt(
          getComputedStyle(document.querySelector(".sticky-product-nav")).height
        )
      : 0;
    const topOffset = headerHeight + productNavHeight;

    const benefitsSection = document.querySelector(".section-product-benefits");
    const mixedBundlesSection = document.querySelector(".mixed-bundles");
    const iconWoolSection = document.querySelector("#product-wool-icons");
    const videoSectionInner = document.querySelector(".video-section__inner");

    let target = null;
    if (benefitsSection) {
      target = benefitsSection;
    } else if (mixedBundlesSection) {
      target = mixedBundlesSection;
    } else if (iconWoolSection) {
      target = iconWoolSection;
    } else if (videoSectionInner) {
      target = videoSectionInner;
    }

    if (target) {
      window.scrollTo({
        top: target.offsetTop - topOffset,
        behavior: "smooth"
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", learnMoreFunction);

// ==================== End Learn More Scroll ====================

// ==================== Start Preorder Function ====================
const preorderFunction = function () {
  const preorderBtn = document.querySelector(".pre-order-button");
  const preorderAddToCartBtn = document.querySelector(
    ".preorder-confirmation__add-to-cart"
  );
  const preorderPopup = document.querySelector(".preorder-confirmation");
  const preorderClose = document.querySelector(".preorder-confirmation__close");

  if (!preorderBtn) return;

  const openPreorderConfirmation = function () {
    preorderPopup.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  };

  const closePreorderConfirmation = function () {
    preorderPopup.classList.add("hidden");
    document.body.style.overflow = "auto";
  };

  // Open
  preorderBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openPreorderConfirmation();
  });

  // Close
  preorderClose.addEventListener("click", closePreorderConfirmation);
  preorderPopup.addEventListener("click", function (e) {
    if (e.target === this) closePreorderConfirmation();
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closePreorderConfirmation();
  });

  // Add to cart
  preorderAddToCartBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closePreorderConfirmation();
    updateCart();
  });
};

document.addEventListener("DOMContentLoaded", preorderFunction);
// ==================== End Preorder Function ====================

// ==================== Start Image Zoom ====================
const featuredImagesZoom = function () {
  // Drift settings for non touch screens
  const driftImgs = [...document.querySelectorAll(".drift-img")];
  if (matchMedia("(hover: hover)").matches) {
    driftImgs.forEach((img) => {
      const pane = img.closest(".keen-slider__slide");
      new Drift(img, {
        paneContainer: pane,
        zoomFactor: 4,
        inlinePane: false,
      });
    });
  }

  // Zoom functionality
  // A) Non touch Screens - Drift
  const featuredImages = document.querySelectorAll(
    ".product-media__gallery .media-container.type-image"
  );
  featuredImages.forEach((img) => {
    img.addEventListener("click", function () {
      const touch = matchMedia("(hover: none)").matches;
      if (!touch) img.classList.toggle("zoom-active");
    });

    // Show Tip for touch screens
    img.addEventListener("touchstart", function () {
      const touchScreenZoomTips = document.querySelectorAll(
        ".touch-screen-tool-tip"
      );

      touchScreenZoomTips.forEach((el) => {
        el.style.display = "block";
        el.classList.add("active-animation");

        setTimeout(() => {
          el.style.display = "none";
          el.classList.remove("active-animation");
        }, 5000);

        img.addEventListener("touchmove", function () {
          el.style.display = "none";
          el.classList.remove("active-animation");
        });
      });
    });
  });

  // B) Touch screens - Pinch
  const pinchZoomWrappers = document.querySelectorAll(".pinch-zoom");
  pinchZoomWrappers.forEach((el) => {
    let pz = new PinchZoom(el, {
      tapZoomFactor: 3,
      minZoom: 0.9,
      draggableUnzoomed: false,
      onZoomStart: function () {
        const touchScreenZoomTips = document.querySelectorAll(
          ".touch-screen-tool-tip"
        );
        touchScreenZoomTips.forEach((el) => el.classList.add("hidden"));
      },
      onDoubleTap: function () {
        const touchScreenZoomTips = document.querySelectorAll(
          ".touch-screen-tool-tip"
        );
        touchScreenZoomTips.forEach((el) => el.classList.add("hidden"));
      },
    });
  });

  // Fix for Samsung devices: Allow vertical scrolling while preserving horizontal swiping and pinch-to-zoom
  // More aggressive solution using CSS touch-action and early event interception
  
  // Android device detection that works in BrowserStack and other testing environments
  function isAndroidDevice() {
    // Check user agent for Android devices (includes Samsung, etc.)
    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const androidRegex = /android/i;
    
    // Also check for Android in the platform if available
    if (navigator.platform) {
      const platform = navigator.platform.toLowerCase();
      if (platform.includes('android')) return true; 
    }
    
    // Primary check: user agent
    if (androidRegex.test(userAgent)) return true;
    
    return false;
  }
  
  if (isAndroidDevice()) {
    const gallery = document.querySelector(".product-media__gallery--slider");
    const pinchZoomParents = document.querySelectorAll(".pinch-zoom-parent");
    const pinchZoomElements = document.querySelectorAll(".pinch-zoom");
    
    // Apply CSS touch-action to allow vertical scrolling and pinch-zoom
    // This tells the browser to allow these gestures natively
    if (gallery) {
      gallery.style.touchAction = 'pan-y pinch-zoom';
    }
    pinchZoomParents.forEach((el) => {
      el.style.touchAction = 'pan-y pinch-zoom';
    });
    pinchZoomElements.forEach((el) => {
      el.style.touchAction = 'pan-y pinch-zoom';
    });
    
    // Store touch state per element to handle multiple simultaneous touches
    const touchStateMap = new WeakMap();
    const handlerMap = new WeakMap();
    
    function getTouchState(el) {
      if (!touchStateMap.has(el)) {
        touchStateMap.set(el, {
          touchStartX: 0,
          touchStartY: 0,
          touchStartTime: 0,
          isVerticalScroll: false,
          isHorizontalSwipe: false,
          touchMoved: false,
          touchCount: 0,
          lastTouchX: 0,
          lastTouchY: 0
        });
      }
      return touchStateMap.get(el);
    }

    function createTouchHandlers(element) {
      // Check if handlers are already attached
      if (handlerMap.has(element)) return;
      handlerMap.set(element, true);
      
      const touchStartHandler = function (e) {
        const state = getTouchState(element);
        state.touchCount = e.touches.length;
        
        if (state.touchCount === 1) {
          state.touchStartX = e.touches[0].clientX;
          state.touchStartY = e.touches[0].clientY;
          state.lastTouchX = state.touchStartX;
          state.lastTouchY = state.touchStartY;
          state.touchStartTime = Date.now();
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchMoved = false;
        } else if (state.touchCount === 2) {
          // Pinch gesture - let PinchZoom handle it
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchMoved = false;
        }
      };

      const touchMoveHandler = function (e) {
        const state = getTouchState(element);
        
        // Handle pinch gestures (2 touches) - let PinchZoom handle it
        if (state.touchCount === 2 || e.touches.length === 2) {
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          return; // Let PinchZoom handle it
        }
        
        // Handle single touch
        if (state.touchCount === 1 && e.touches.length === 1) {
          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;
          const deltaX = currentX - state.touchStartX;
          const deltaY = currentY - state.touchStartY;
          const absDeltaX = Math.abs(deltaX);
          const absDeltaY = Math.abs(deltaY);
          
          // Calculate movement since last touch event
          const moveX = currentX - state.lastTouchX;
          const moveY = currentY - state.lastTouchY;
          state.lastTouchX = currentX;
          state.lastTouchY = currentY;

          // Determine direction after initial movement (lower threshold for faster detection)
          if (!state.touchMoved && (absDeltaX > 5 || absDeltaY > 5)) {
            state.touchMoved = true;
            
            // More lenient detection - prioritize vertical scrolling
            if (absDeltaY > absDeltaX * 1.2 && absDeltaY > 10) {
              // Primarily vertical - allow page scroll
              state.isVerticalScroll = true;
              state.isHorizontalSwipe = false;
            } else if (absDeltaX > absDeltaY * 1.5 && absDeltaX > 15) {
              // Primarily horizontal - let slider handle it
              state.isVerticalScroll = false;
              state.isHorizontalSwipe = true;
            }
          } else if (state.touchMoved) {
            // Update direction based on continued movement
            if (absDeltaY > absDeltaX * 1.2) {
              state.isVerticalScroll = true;
              state.isHorizontalSwipe = false;
            } else if (absDeltaX > absDeltaY * 1.5) {
              state.isVerticalScroll = false;
              state.isHorizontalSwipe = true;
            }
          }

          // If it's a vertical scroll, manually scroll the page
          if (state.isVerticalScroll && !state.isHorizontalSwipe) {
            // Manually scroll the window based on touch movement - this bypasses all event blocking
            // Use a multiplier to make scrolling feel more natural (native scroll feels more responsive)
            if (Math.abs(moveY) > 0) {
              const scrollMultiplier = 14; // Multiplier to match natural scroll feel
              window.scrollBy({
                top: -moveY * scrollMultiplier, // Negative because touch Y increases downward but scroll should go up
                behavior: 'auto'
              });
            }
            
            // Prevent default and stop propagation to prevent libraries from interfering
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            return false;
          }
        }
      };

      const touchEndHandler = function (e) {
        const state = getTouchState(element);
        // Reset flags after a delay
        setTimeout(() => {
          state.touchMoved = false;
          state.isVerticalScroll = false;
          state.isHorizontalSwipe = false;
          state.touchCount = 0;
          state.lastTouchX = 0;
          state.lastTouchY = 0;
        }, 100);
      };

      // Store handlers for potential cleanup
      element._samsungScrollFix = {
        touchstart: touchStartHandler,
        touchmove: touchMoveHandler,
        touchend: touchEndHandler
      };

      // Use capture phase to intercept before other handlers
      element.addEventListener("touchstart", touchStartHandler, { passive: true, capture: true });
      element.addEventListener("touchmove", touchMoveHandler, { passive: false, capture: true });
      element.addEventListener("touchend", touchEndHandler, { passive: true, capture: true });
    }

    // Add handlers to gallery, pinch-zoom parents, and pinch-zoom elements
    const elementsToHandle = gallery 
      ? [gallery, ...Array.from(pinchZoomParents), ...Array.from(pinchZoomElements)]
      : [...Array.from(pinchZoomParents), ...Array.from(pinchZoomElements)];
    
    elementsToHandle.forEach((element) => {
      if (!element) return;
      createTouchHandlers(element);
    });
  }
};
document.addEventListener("DOMContentLoaded", featuredImagesZoom);
// ==================== End Image Zoom ====================


// ==================== Sticky ATC ========================
function initStickyAddToCart() {
  const originalCTA = document.querySelector("#main-product .product-form__cta");
  if (!originalCTA) return;

  document.querySelectorAll(".sticky-cta-clone").forEach(el => el.remove());

  const stickyCTA = document.createElement("div");
  stickyCTA.className = "product-form__cta sticky-cta-clone";
  document.body.appendChild(stickyCTA);

  const header = document.querySelector(".site-header, .header, .shopify-section-header");
  const sizeBlock = document.querySelector(".product-form__option-size");
  const okeReview = document.querySelector(".oke-fit-review");
  const pillsNav = document.querySelector(".feature-pills__nav");
  const isBackpack = document.body.classList.contains("product-backpack");

  const isVisible = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || el.classList.contains("hidden")) return false;
    const r = el.getClientRects();
    return r && r.length > 0;
  };

  const getPrimaryBtn = () => {
    const scope = originalCTA.querySelector(".size-selected") || originalCTA;
    const klaviyo = scope.querySelector(".klaviyo-bis-trigger");
    if (isVisible(klaviyo)) return { el: klaviyo, type: "klaviyo", text: klaviyo.textContent.trim() };

    const atc = scope.querySelector(".add-to-cart-button");
    if (isVisible(atc)) return { el: atc, type: "atc", text: atc.textContent.trim() };

    const sold = scope.querySelector(".sold-out-button");
    if (isVisible(sold)) return { el: sold, type: "soldout", text: sold.textContent.trim() };

    const selectSizeBtn = originalCTA.querySelector(".select-size-button");
    if (selectSizeBtn) {
      const spanAdd = selectSizeBtn.querySelector(".select-size-button__add-to-cart");
      const spanSelect = selectSizeBtn.querySelector(".select-size-button__select-a-size");
      let text = "";
      if (spanAdd && getComputedStyle(spanAdd).display !== "none") text = spanAdd.textContent.trim();
      else if (spanSelect && getComputedStyle(spanSelect).display !== "none") text = spanSelect.textContent.trim();
      else text = selectSizeBtn.textContent.trim();
      return { el: selectSizeBtn, type: "select", text };
    }

    return null;
  };

  const scrollToSizeBlock = () => {
    if (!sizeBlock) return;
    const offset = header ? header.offsetHeight : 0;
    const y = sizeBlock.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const scrollTopSmooth = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const inViewportByRatio = (el, minRatio = 0.25) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const intersect = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    const visible = intersect > 0;
    const ratio = rect.height > 0 ? intersect / rect.height : 0;
    return visible && ratio >= minRatio;
  };

  let lastSignature = "";

  const renderSticky = () => {
    const primary = getPrimaryBtn();
    if (!primary) return;
    const signature = primary.type + "|" + primary.text;
    if (signature === lastSignature && stickyCTA.querySelector("button")) return;
    lastSignature = signature;
    stickyCTA.innerHTML = "";
    const btn = document.createElement("button");
    btn.className = "btn-cta btn--black sticky-cta-btn";
    btn.textContent = primary.text;
    stickyCTA.appendChild(btn);
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const current = getPrimaryBtn();
      if (!current) return;
      if (current.type === "select" || current.type === "soldout") {
        scrollToSizeBlock();
        return;
      }
      if (current.type === "atc" || current.type === "klaviyo") {
        current.el.click();
        scrollTopSmooth();
      }
    });
  };

  // ✅ Final fixed visibility logic
  const toggleStickyCTA = () => {
    if (window.innerWidth >= 750) {
      stickyCTA.classList.remove("is-sticky");
      return;
    }

    // Never show on page load before scroll
    if (window.scrollY < 1) {
      stickyCTA.classList.remove("is-sticky");
      return;
    }

    const primary = getPrimaryBtn();
    const mainVisible = inViewportByRatio(primary?.el || originalCTA, 0.25);

    let triggerReached = false;
    if (isBackpack && pillsNav) {
      const rect = pillsNav.getBoundingClientRect();
      triggerReached = rect.top <= window.innerHeight;
    } else if (!isBackpack && okeReview) {
      const rect = okeReview.getBoundingClientRect();
      triggerReached = rect.top <= window.innerHeight;
    }

    const shouldShow = triggerReached && !mainVisible;
    stickyCTA.classList.toggle("is-sticky", shouldShow);
  };
  // ✅ End change

  const observer = new MutationObserver(() => {
    renderSticky();
    toggleStickyCTA();
  });
  observer.observe(originalCTA, { childList: true, subtree: true, attributes: true, characterData: true });

  setInterval(renderSticky, 400);

  window.addEventListener("scroll", toggleStickyCTA, { passive: true });
  window.addEventListener("resize", toggleStickyCTA);

  renderSticky();
  toggleStickyCTA();
}

initStickyAddToCart();

// ==================== End Sticky Add to Cart Button ====================

// ==================== Start Shipping & Returns Modal ====================
// Open & Close Shipping & Returns Modal
const shippingReturnsBtns = document.querySelectorAll(".shipping-tab");

const shippingReturnsFunction = function () {
  if (shippingReturnsBtns.length < 1) return;
  const shippingReturnsPopup = document.querySelector(
    ".shipping-returns-popup"
  );
  const shippingReturnsClose = document.querySelector(
    ".shipping-returns-popup__close"
  );

  const openSizeGuideModal = function () {
    shippingReturnsPopup.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    let returnsExchanges = document.querySelector('.shipping-returns__container');
    returnsExchanges.scrollIntoView({ behavior: "smooth" });
  };

  const closeSizeGuideModal = function () {
    shippingReturnsPopup.classList.add("hidden");
    document.body.style.overflow = "auto";
  };

  const openReturnsModal = function(){
    setTimeout(() => {
    let returnsExchanges = document.querySelector('.returns__container');
    if (returnsExchanges) {
      returnsExchanges.scrollIntoView({ behavior: "smooth" });
    }
  }, 100);
  }

  let returnsModal = document.querySelector('.shipping-tab--returns');

  returnsModal.addEventListener("click", openReturnsModal);



  // Open Size Guide
  shippingReturnsBtns.forEach((btn) =>
    btn.addEventListener("click", openSizeGuideModal)
  );

  // Close Fit
  shippingReturnsClose.addEventListener("click", closeSizeGuideModal);
  shippingReturnsPopup.addEventListener("click", function (e) {
    if (e.target === this) closeSizeGuideModal();
  });
  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeSizeGuideModal();
  });
};

document.addEventListener("DOMContentLoaded", shippingReturnsFunction);
// ==================== End Shipping & Returns Modal ====================

// ==================== Start hide BIS hidden options ====================
const hideBIShiddenOptions = function () {
  const bisBtns = document.querySelectorAll(".klaviyo-bis-trigger");
  if (bisBtns.length < 1) return;
  bisBtns.forEach((btn) =>
    btn.addEventListener("click", function () {
      setTimeout(() => {
        const iframe = document.querySelector("#klaviyo-bis-iframe");
        const doc = iframe.contentDocument
          ? iframe.contentDocument
          : iframe.contentWindow
          ? iframe.contentWindow.document
          : iframe.document;
        const options = doc.querySelectorAll(
          "#klaviyo-bis-modal select option"
        );
        options.forEach((option) => {
          if (option.textContent.includes("_")) option.remove();
        });

        if (typeof discontinued_colors !== "undefined") {
          const colors = discontinued_colors.split(",").map((c) => c.trim());
          options.forEach((option) => {
            let discontinued_option = colors.some((color) =>
              option.text.includes(color)
            );
            if (discontinued_option) {
              option.remove();
            }
          });
        }
      }, 500);
    })
  );
};

document.addEventListener("DOMContentLoaded", hideBIShiddenOptions);
// ==================== End hide BIS hidden options ====================

// ==================== Start Select a size ====================
const allSizeLabels = document.querySelectorAll(
  ".product-form__option-size .product-form__button-label"
);

allSizeLabels.forEach((sizeLabel) => {
  sizeLabel.addEventListener("click", function () {
    const form = this.closest(".product-form");
    const isBundleBuilder = form?.classList.contains("product-form--bundle-builder") ?? false;

    // 🔹 Detect if product is Black Friday Variety
    const isBlackFridayVariety =
      Array.isArray(window?.productData?.tags) &&
      window.productData.tags.includes("black-friday-variety");

    if (!isBundleBuilder) {
      if (!this.classList.contains("active")) {
        const relatedInput = document.querySelector(
          `input[id="${this.getAttribute("for")}"]`
        );
        const variantRadios = document.querySelector("variant-radios");

        // 1 - Add Active class to this label
        allSizeLabels.forEach((el) => el.classList.remove("active"));
        this.classList.add("active");

        // 2 - Add product-form--size-selected class to the product form
        form.classList.add("product-form--size-selected");

        // 3 - Trigger variant change if checked
        if (relatedInput.hasAttribute("checked")) {
          variantRadios.onVariantChange();
        }
      }
    }

    // 🧩 Keep Variety Label fixed — even after size change
    if (isBlackFridayVariety) {
      const fixedVariantEl = document.querySelector(
        ".bundle-builder-row__selected-variant"
      );
      const combinedColors =
        window?.giftSetColors ||
        fixedVariantEl?.dataset?.fixedLabel ||
        fixedVariantEl?.textContent?.trim();

      if (fixedVariantEl && combinedColors) {
        fixedVariantEl.dataset.fixedLabel = combinedColors; // store once
        fixedVariantEl.textContent = combinedColors;
      }
    }
  });
});

// ====== "Select a Size" Button ======
const selectASizeBtnClick = function () {
  const btn = document.querySelector(".select-size-button");
  btn?.addEventListener("click", (e) => {
    const addToCartEl = btn.querySelector(".select-size-button__add-to-cart");
    const selectASizeEl = btn.querySelector(
      ".select-size-button__select-a-size"
    );
    e.preventDefault();
    addToCartEl.style.display = "none";
    selectASizeEl.style.display = "block";
  });
};
document.addEventListener("DOMContentLoaded", selectASizeBtnClick);
// ==================== End Select a size ====================


// ==================== Start UGC Video ====================
const ugcVideoCards = document.querySelectorAll(".ugc-videos__video-card");
ugcVideoCards.forEach((card) => {
  card.addEventListener("click", function () {
    const ugcMainVideo = this.closest(
      ".ugc-videos__video-card-container"
    ).querySelector(".video-card__main");

    // 1- Full Screen
    ugcMainVideo.play();
    ugcMainVideo.requestFullscreen();

    // 2- Pause the video
    ugcMainVideo.addEventListener("fullscreenchange", function () {
      if (!document.fullscreenElement) {
        ugcMainVideo.pause();
      }
    });
  });
});
// ==================== End UGC Video ====================

// ==================== Start Product Dimensions ====================
const productDimensions = function () {
  const measurementsBtn = document.querySelector(".measurements-btn");
  const clothingMeasurements = document.querySelector(".clothing-measurements");
  if (!measurementsBtn) return;
  measurementsBtn.addEventListener("click", (e) => {
    e.preventDefault();

    // Open Size Guide Modal
    if (sizeGuidePopup) openSizeGuideModal(sizeGuidePopup);

    // Scroll to Clothing Measurements
    if (clothingMeasurements)
      clothingMeasurements.scrollIntoView({ behavior: "smooth" });
  });
};

// Init on load
document.addEventListener("DOMContentLoaded", productDimensions);
// ==================== End Product Dimensions ====================

// ==================== Start Customer Images Button ====================
const customerImgesFunction = function () {
  const customerImagesSection = document.querySelector("#customer-images");
  const customerImagesBtns = document.querySelectorAll(".customer-images-btn");

  if (customerImagesSection) {
    customerImagesBtns.forEach((btn) => {
      // 1- Show Customer Images Button
      btn.style.display = "block";

      // 2- Click Event, Scroll to Customer Images Section
      btn.addEventListener("click", function (e) {
        const headerHeigt = parseInt(
          getComputedStyle(document.querySelector(".mega-sticky-header")).height
        );
        const productNavHeight = parseInt(
          getComputedStyle(document.querySelector(".sticky-product-nav")).height
        );
        const topOffset = headerHeigt + productNavHeight;

        e.preventDefault();

        document.body.scrollTop =
          customerImagesSection.offsetTop - topOffset + 1;
        document.documentElement.scrollTop =
          customerImagesSection.offsetTop - topOffset + 1;
      });
    });
  }
};
// document.addEventListener('DOMContentLoaded', customerImgesFunction);
// ==================== End Customer Images Button ====================

// ==================== Start Show Tall/Petite Klaviyo Popups ====================
document
  .querySelector(".klaviyo-btn--tall-mobile")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "UujAf9"]);
  });
document
  .querySelector(".klaviyo-btn--tall-desktop")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "TL9hRu"]);
  });

document
  .querySelector(".klaviyo-btn--petite-mobile")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "RGFxX9"]);
  });
document
  .querySelector(".klaviyo-btn--petite-desktop")
  ?.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "V34hTz"]);
  });

// ==================== End Show Tall/Petite Klaviyo Popups ====================

// ==================== Start Micron Chart ====================
const micronChart = function () {
  const progress = document.querySelector(".micron-chart__progress");
  const progressValue = document.querySelector(".micron-chart__progress-value");
  if (!progress) return;
  const progressWidth = parseInt(getComputedStyle(progress).width);
  const progressValueWidth = parseInt(getComputedStyle(progressValue).width);
  const remainingProgressWidth = progressWidth - progressValueWidth;
  const percentage = progressValue.dataset.percentage;
  const pxToMove = (remainingProgressWidth * percentage) / 100;

  progressValue.style.left = `${pxToMove}px`;
};

document.addEventListener("DOMContentLoaded", micronChart);
window.addEventListener("resize", micronChart);
// ==================== End Micron Chart ====================

// ==================== Start Micron Modal ====================
const micronModal = document.querySelector(".micron-modal");

const openMicronModal = (micronModal) => {
  micronModal.classList.remove("hidden");
  document.body.classList.add("micron-modal-opened");
};

const closeMicronModal = (micronModal) => {
  micronModal.classList.add("hidden");
  document.body.classList.remove("micron-modal-opened");
};

const micronModalFunction = () => {
  if (!micronModal) return;
  const iconOpen = document.querySelector(
    ".micron-list-item .icon-question-mark"
  );
  const iconClose = micronModal.querySelector(".icon-close");

  // Open
  if (iconOpen) {
    iconOpen.addEventListener("click", () => openMicronModal(micronModal));
  } else {
    console.log("iconOpen not found"); // For debugging
  }

  // Close
  iconClose.addEventListener("click", () => closeMicronModal(micronModal));
  micronModal.addEventListener("click", function (e) {
    if (e.target === this) closeMicronModal(micronModal);
  });
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMicronModal(micronModal);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (micronModal) micronModalFunction();
});
// ==================== End Micron Modal ====================

// ==================== Start singles and packs buttons ====================
const singleAndPacksBtns = function () {
  const btns = document.querySelectorAll(".singles-and-packs__btn");

  btns.forEach((btn) => {
    btn.addEventListener("click", function () {
      if (btn.classList.contains("active")) return;

      const btnBg = document.querySelector(
        ".singles-and-packs__btn-background"
      );
      const productFormContainer = document.querySelector(
        ".singles-and-packs__product-form"
      );
      const bundleBuilderContainer = document.querySelector(
        ".singles-and-packs__bundle-builder"
      );
      const savingsEls = document.querySelectorAll(
        ".singles-and-packs__savings"
      );
      const singlePrice = document.querySelectorAll(".product-price");
      const packPrice = document.querySelectorAll(".pack-price");
      const singleVariantRadiosEl = document.querySelector(
        ".singles-and-packs__product-form variant-radios"
      );

      // If packs
      if (btn.dataset.type === "packs") {
        // 1. active class
        btns.forEach((el) => el.classList.remove("active"));
        btn.classList.add("active");

        // 2. Background animation
        btnBg.classList.remove("active-singles");
        btnBg.classList.add("active-packs");

        // 3. Show bundle builder
        productFormContainer.classList.add("hidden");
        bundleBuilderContainer?.classList.remove("hidden");

        // 4. Hide savings
        savingsEls.forEach((el) => el.classList.add("visibility-hidden"));

        // 5. Show pack price
        singlePrice.forEach((price) => price.classList.add("hidden"));
        packPrice.forEach((price) => price.classList.remove("hidden"));
      }

      // If singels
      if (btn.dataset.type === "singles") {
        // 1. active class
        btns.forEach((el) => el.classList.remove("active"));
        btn.classList.add("active");

        // 2. Background animation
        btnBg.classList.add("active-singles");
        btnBg.classList.remove("active-packs");

        // 3. Show product form
        productFormContainer.classList.remove("hidden");
        bundleBuilderContainer?.classList.add("hidden");

        // 4. Show savings
        savingsEls.forEach((el) => el.classList.remove("visibility-hidden"));

        // 5. Show product price
        packPrice.forEach((price) => price.classList.add("hidden"));
        singlePrice.forEach((price) => price.classList.remove("hidden"));

        // 6. Update product info
        singleVariantRadiosEl.getSelectedOptions();
        singleVariantRadiosEl.getVariantJSON();
        singleVariantRadiosEl.getSelectedVariant();
        singleVariantRadiosEl.updateProductInfo();
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", singleAndPacksBtns);
// ==================== End singles and packs switch ====================
// ==================== Keep Black Friday Variety Label Fixed ====================
function keepVarietyLabelFixed() {
  const isVariety =
    Array.isArray(window?.productData?.tags) &&
    window.productData.tags.includes("black-friday-variety");
  if (!isVariety) return;

  const fixedEl = document.querySelector(".bundle-builder-row__selected-variant");
  if (!fixedEl) return;

  let fixedText = "";

  if (window?.giftSetColors) {
    fixedText = window.giftSetColors
      .split(",")
      .map((c) => c.trim())
      .join(" / ");
  } else if (fixedEl.dataset.fixedLabel) {
    fixedText = fixedEl.dataset.fixedLabel
      .split(",")
      .map((c) => c.trim())
      .join(" / ");
  } else {
    fixedText = fixedEl.textContent.trim().replace(/,/g, " / ");
  }

  if (!fixedText) return;

  fixedEl.dataset.fixedLabel = fixedText;

  const enforce = () => {
    const el = document.querySelector(".bundle-builder-row__selected-variant");
    if (el && el.textContent.trim() !== fixedText) {
      el.textContent = fixedText;
    }
  };

  const observer = new MutationObserver(enforce);
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
  });

  document.addEventListener("change", enforce);
  document.addEventListener("click", enforce);

  enforce();
}

document.addEventListener("DOMContentLoaded", keepVarietyLabelFixed);

// ==================== Hide Remove Icon + Auto-Add Rows ====================
document.addEventListener("DOMContentLoaded", () => {
  const style = document.createElement("style");
  style.textContent = `
    .bundle-builder-row__outer .icon-remove {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  const handle = window.location.pathname.split("/products/")[1]?.replace(/\/$/, "");

  const autoAddHandles = [
    "mens-build-your-own-5-pack",
    "women-s-build-your-own-5-pack",
    "mens-5-pack-gift-set-variety",
    "women-s-5-pack-gift-set-variety"
  ];

  if (autoAddHandles.includes(handle)) {
    const addRowBtn = document.querySelector(".bundle-builder__add-row");
    if (!addRowBtn) return;

    addRowBtn.click();

    setTimeout(() => {
      const btnAgain = document.querySelector(".bundle-builder__add-row");
      if (btnAgain) btnAgain.click();
    }, 1000);
  }
});

// ==================== Start Tall/Petite Klaviyo Popups ====================
let productHandle = document.querySelector('.main-product')?.dataset?.handle || "";

if (productHandle.includes('tall')) {
  let tallPopupSignup = document.querySelector('.vertical-popup-signup--tall');

  let alreadyShown = sessionStorage.getItem('tallPopupShown') === 'true';

  if (alreadyShown && tallPopupSignup) {
    tallPopupSignup.classList.remove("hidden");
  } else {
    setTimeout(function() {
      openPopup('Rcq94G', 'tallPopupShown', true);
      if (tallPopupSignup) tallPopupSignup.classList.remove("hidden");
    }, 10000);
  }

  if (tallPopupSignup) {
    tallPopupSignup.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('Rcq94G', 'tallPopupShown', false);
    });
  }

} else if (productHandle.includes('petite')) {
  let petitePopupSignupDesktop = document.querySelector('.vertical-popup-signup--petite-desktop');
  let petitePopupSignupMobile = document.querySelector('.vertical-popup-signup--petite-mobile');

  let alreadyShown = sessionStorage.getItem('petitePopupShown') === 'true';

  if (alreadyShown) {
    if (petitePopupSignupMobile) petitePopupSignupMobile.classList.remove("hidden");
    if (petitePopupSignupDesktop) petitePopupSignupDesktop.classList.remove("hidden");
  } else {
    setTimeout(function() {
      if (window.innerWidth < 749) {
        openPopup('RGFxX9', 'petitePopupShown', true);
      } else {
        openPopup('V34hTz', 'petitePopupShown', true);
      }
      if (petitePopupSignupMobile) petitePopupSignupMobile.classList.remove("hidden");
      if (petitePopupSignupDesktop) petitePopupSignupDesktop.classList.remove("hidden");
    }, 10000);
  }

  if (petitePopupSignupDesktop) {
    petitePopupSignupDesktop.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('V34hTz', 'petitePopupShown', false);
    });
  }

  if (petitePopupSignupMobile) {
    petitePopupSignupMobile.addEventListener('click', function(e) {
      e.preventDefault();
      openPopup('RGFxX9', 'petitePopupShown', false);
    });
  }
}

function openPopup(popupId = 'Rcq94G', sessionKey = null, checkSession = true) {
  if (checkSession && sessionKey && sessionStorage.getItem(sessionKey) === 'true') {
    return;
  }

  if (window._klOnsite && typeof window._klOnsite.push === 'function') {
    setTimeout(() => {
      window._klOnsite.push(['openForm', popupId]);
      if (sessionKey) sessionStorage.setItem(sessionKey, 'true');
    }, 200);
  } else {
    console.warn('Klaviyo not ready yet — retrying...');
    setTimeout(() => openPopup(popupId, sessionKey, checkSession), 500);
  }
}

// ===================== Petite Redirect ======================== //
document.addEventListener('DOMContentLoaded', function() {
  const targetElement = document.querySelector('.hide-mobile.klaviyo-btn.klaviyo-btn--petite-desktop');
  
  if (targetElement) {
    targetElement.addEventListener('click', function(event) {
      event.preventDefault();
      window.location.href = '/collections/womens-petite';
    });
  }
});
